import { render, staticRenderFns } from "./AvisoDePrivacidad.vue?vue&type=template&id=3c94c8da&"
import script from "./AvisoDePrivacidad.vue?vue&type=script&lang=js&"
export * from "./AvisoDePrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./AvisoDePrivacidad.vue?vue&type=style&index=0&id=3c94c8da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports